module.exports = __webpack_public_path__ + "img/ic-system-viabus.5b5f16a5.svg";